import { render } from "./Footer.vue?vue&type=template&id=5e5c2cc5"
const script = {}

import exportComponent from "E:\\Work\\Tabnova SPA\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__